import VerticalProgramListItem from "./VerticalProgramListItem";

export default VerticalProgramListItem;
